import { checkWithMediumJson } from './checkWithMediumJson';

/**
 * ตรวจสอบค่า HDL โดยใช้ค่าปกติจาก medium.json
 */
export default async (value, age, gender) => {
  return await checkWithMediumJson(value, 'HDL', gender, age, 'HDL');
};
